import { render } from "./NotificationsElement.vue?vue&type=template&id=795fbb50&scoped=true"
import script from "./NotificationsElement.vue?vue&type=script&lang=js"
export * from "./NotificationsElement.vue?vue&type=script&lang=js"

import "./NotificationsElement.vue?vue&type=style&index=0&id=795fbb50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795fbb50"]])

export default __exports__